/* eslint-disable no-use-before-define */

/**
 * CardList 내에서 Max Month 반환
 * ui/topInfo/CardBenefit/CardMonthlyFree.jsx에서 쓰인다.
 */
export function getMaxMonth(cardList) {
  let maxNormalMonth = 0;
  let maxInterestFreeMonth = 0;

  for (const card of Object.keys(cardList)) {
    for (const { duration, interestTypeText } of cardList[card]) {
      if (interestTypeText === "일반") {
        maxNormalMonth = Math.max(
          maxNormalMonth,
          Math.max.apply(null, duration)
        );
      } else if (interestTypeText === "부분") {
        maxInterestFreeMonth = Math.max(
          maxInterestFreeMonth,
          Math.max.apply(null, duration)
        );
      }
    }
  }
  return {
    month: maxNormalMonth || maxInterestFreeMonth,
    free: maxNormalMonth ? "무이자" : "부분무이자",
  };
}

/**
 * 카드 청구할인 적용된 가격 반환
 * ui/topInfo/CardBenefit/CardBillingDiscount.jsx에서 쓰인다.
 */
export function getBillingDiscountPrice(
  discountInfosPrice,
  metaCardDiscountInfo
) {
  const { percent, card } = metaCardDiscountInfo.htmlContent;
  const DISCOUNT_RATIO = 1 - percent / 100;
  const {
    cardDuplicateDiscountInfos,
  } = TMON.oApp.htStorage.htStaticData.htDealInfo;
  const { cardDuplicateDiscountPrice, cards } =
    cardDuplicateDiscountInfos || {};
  let price;
  /* BDEV-646 중복할인카드사와 청구할인카드사와 일치 여부에 따라 청구할인 가격 계산 */
  if (cardDuplicateDiscountInfos && cards.includes(card)) {
    price = cardDuplicateDiscountPrice;
  } else {
    price = discountInfosPrice;
  }
  const billingDiscountPrice = price * DISCOUNT_RATIO;
  const trucatedPrice = Math.floor(billingDiscountPrice);
  return trucatedPrice;
}

/**
 * card layer options 반환
 */
export function getCardLayerOptions(cardDiscountPopup) {
  const cardInfo = TMON.oApp.htStorage.htStaticData.cardInfo
    ? TMON.oApp.htStorage.htStaticData.cardInfo
    : null;
  const cardDuplicateDiscountInfos = TMON.oApp.htStorage.htStaticData.htDealInfo
    .cardDuplicateDiscountInfos
    ? JSON.parse(
        JSON.stringify(
          TMON.oApp.htStorage.htStaticData.htDealInfo.cardDuplicateDiscountInfos
        ).replace(/\\"즉시할인\\"/g, "'즉시할인'")
      )
    : null;
  return {
    dealSrls: TMON.htStaticData.htDealInfo.dealNo,
    cardInfo,
    cardDuplicateDiscountInfos,
    cardBillingDiscount: TMON.htStaticData.isMetaCardDiscount,
    cardCompanyName: cardDiscountPopup ? cardDiscountPopup.extraField : '',
    cardPopupContents: cardDiscountPopup ? cardDiscountPopup.htmlContent.contents : ''
  };
}

/**
 * [TWORK-1423] 전시 어드민에 등록되어 있는 카드사 배열을 노출 기간과 등록 순서에 맞춰 배열 재구성 및 HTML 내용 파싱
 *  카드사는 한 개만 노출되어야 하는데 만약 노출 기간이 겹칠경우 우선순위에 따라 카드사가 노출되며, 우선순위까지 똑같다면 최신에 등록된 카드사가 노출된다.
 *  @param {array} metaCardDiscountArr 전시 어드민에 등록되어 있는 메타 청구할인 카드사 배열
 */
export function getFormattedCardDiscount(metaCardDiscountArr) {
  let formattedDiscountArr = [];
  formattedDiscountArr = metaCardDiscountArr
    // HTML내용 파싱
    .map((metaCardDiscount) => {
      const parseHtmlArr = metaCardDiscount;
      let { htmlContent } = parseHtmlArr;
      // 전시 어드민 데이터에 불필요한 태그 제거
      htmlContent = htmlContent.replaceAll("<p>", "");
      htmlContent = htmlContent.replaceAll("</p>", "");
      htmlContent = htmlContent.replaceAll("<br>", "");
      parseHtmlArr.htmlContent = JSON.parse(htmlContent);
      return parseHtmlArr;
    });

  // 노출 기간에 해당하는 카드사가 여러개면 배열 정렬 필요
  if (formattedDiscountArr.length > 1) {
    formattedDiscountArr = formattedDiscountArr
      // 전시 어드민에 등록한 순서로 내림차순
      .sort((a, b) => {
        return b.bannerSeqNo - a.bannerSeqNo;
      })
      // 설정해놓은 노출 순서로 내림차순
      .sort((a, b) => {
        return a.viewPriorityRank - b.viewPriorityRank;
      });
  }
  return formattedDiscountArr[0];
}
